module.exports = __webpack_public_path__ + "media/images/metronic/loading-spinner-grey-17173f09d4e71de7ed0464fd0d899600.gif";